
import TopNavBar from "@/components/common/TopNavBar.vue"

export default {
  components: {
    "jt-top-nav-bar": TopNavBar
  }
}
